import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import React from 'react';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import GroupsBulkSelect from '../../GroupsBulkSelect.jsx';
import CustomRadio from '../../CustomRadio.jsx';
import ImpactedGroups from '../../group-form-field/SelectedGroups.jsx';
import EmployeesField from '../../EmployeesField.jsx';
import AuthorizedAction from '../../AuthorizedAction.js';

export const uploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  { label: 'Add new participant to an existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

const ParticipantsSelect = ({
  selectedGroups,
  selectedUngrouped,
  onSelectGroup,
  onSelectAllGroupEmployees,
  onSelectUngroupedEmployee,
  ungroupedSearchParams,
  uploadMethod,
  setUploadMethod,
  replaceMethod,
  setReplaceMethod,
  onShowGroupModal,
  onShowManageGroupModal,
  onShowManageParticipantsModal,
  editing,
  currentCSVDownloadButton,
  exampleCSVDownloadButton,
}) => {
  return (
    <React.Fragment>
      <p className="text-muted m-b-24">Select Group(s) or People.</p>
      <div className="m-b-18">
        <CustomRadio
          name="participantsUploadMethod"
          checkedValue={uploadMethod}
          options={uploadMethodOptions}
          action={setUploadMethod}
        />
      </div>

      {uploadMethod === 'csv' ? (
        <React.Fragment>
          {setReplaceMethod &&
          (Object.keys(selectedGroups).length || selectedUngrouped.length) ? (
            <Row className="m-b-48">
              <Col xs={12}>
                <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                  <h3>Existing Structure</h3>
                </div>
              </Col>
              <Col xs={12}>
                <div className="m-b-18">
                  <CustomRadio
                    name="participantsReplaceMethod"
                    checkedValue={replaceMethod}
                    options={replaceOptions}
                    action={setReplaceMethod}
                  />
                </div>
              </Col>
              <Col xs={12}>{editing ? currentCSVDownloadButton : null}</Col>
            </Row>
          ) : null}
          <Row>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Bulk CSV Upload</h3>
              </div>
            </Col>
            <Col xs={12}>
              <div className="m-b-18">{exampleCSVDownloadButton}</div>
            </Col>
            <Col xs={12}>
              <Field
                id="participantsFormCsvFile"
                name="csv_file"
                type="file"
                component={FieldGroup}
                accept=".csv"
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : null}

      {uploadMethod === 'manually' ? (
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel className="flex flex-justify">
                <div>
                  Select Group, Team or Department(s)
                  <strong className="bordered bordered-xs text-muted m-l-8">
                    Total:&nbsp;
                    <span className="text-info-brand count">
                      {Object.keys(selectedGroups).length}
                    </span>
                  </strong>
                </div>
                {onShowGroupModal ? (
                  <AuthorizedAction action="create" subject="group">
                    <button
                      type="button"
                      className="btn-clear btn-link"
                      onClick={onShowGroupModal}
                    >
                      + Add Group
                    </button>
                  </AuthorizedAction>
                ) : null}
              </ControlLabel>
              <GroupsBulkSelect
                selected={selectedGroups}
                handleSelect={onSelectGroup}
                onShowGroupModal={onShowGroupModal}
                showArchived={editing}
                customClass="m-0"
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <ImpactedGroups
              selected={selectedGroups}
              handleSelect={onSelectGroup}
              onSelectAllGroupEmployees={onSelectAllGroupEmployees}
              onShowManageModal={onShowManageGroupModal}
            />
          </Col>
          <Col xs={12}>
            <div className="m-b-24">
              <Field
                id="people"
                name="people"
                selected={selectedUngrouped}
                handleSelect={onSelectUngroupedEmployee}
                additionalSearchParams={ungroupedSearchParams}
                onShowManageModal={onShowManageParticipantsModal}
                title="Select Ungrouped Employee(s)"
                component={EmployeesField}
              />
            </div>
          </Col>
        </Row>
      ) : null}
    </React.Fragment>
  );
};

export default ParticipantsSelect;
